module.exports = __webpack_public_path__ + "static/media/sergey_s.fa0302d5.jpg";